import { updateDynamicText } from '@/utils'
import { sanitizeDynamicText } from '@/utils/tinyMCE/updateDynamicText/sanitizeDynamicText'
import { withoutActiveHtml } from '@/utils/tinyMCE/withoutActiveHtml'

/** What `updateDynamicText` merges besides the HTML: the case, the funeral home, the formats. */
type MergeInputs = Record<string, unknown> & {
  environment: Parameters<typeof sanitizeDynamicText>[0]['environment']
}

/**
 * Stored box HTML merged with the case, as a surface paints it: the case's
 * values filled in (`updateDynamicText`), the merge cleaned
 * (`sanitizeDynamicText`), and active content taken out (`withoutActiveHtml`),
 * as `PageText.js` does for the canvas.
 */
export const mergedBoxHtml = (html: string, inputs: MergeInputs): string =>
  withoutActiveHtml(
    sanitizeDynamicText({
      html: updateDynamicText({ initialHtml: html, ...inputs }) || '',
      environment: inputs.environment,
    }),
  )
